module.exports = __webpack_public_path__ + "img/05.d5857937.jpg";